/* eslint-disable */

/** Types of levels the customer can have. */
export enum StatusLevel {
  GREEN = "GREEN",
  GOLD = "GOLD",
  /**
   * GOLD_5K - Deprecated. Accounts were migrated to GOLD_7_5K
   *
   * @deprecated
   */
  GOLD_5K = "GOLD_5K",
  GOLD_7_5K = "GOLD_7_5K",
  GOLD_10K = "GOLD_10K",
  /**
   * SQUARE_GREEN - Deprecated. Accounts were migrated to GREEN
   *
   * @deprecated
   */
  SQUARE_GREEN = "SQUARE_GREEN",
  /**
   * SQUARE_GOLD - Deprecated. Accounts were migrated to GOLD_10k
   *
   * @deprecated
   */
  SQUARE_GOLD = "SQUARE_GOLD",
  /** SQUARE_15K - Custom levels for Square-internal uses of Cash. Use carefully. */
  SQUARE_15K = "SQUARE_15K",
  SQUARE_25K = "SQUARE_25K",
  SQUARE_50K = "SQUARE_50K",
  SQUARE_150K = "SQUARE_150K",
  SQUARE_500K = "SQUARE_500K",
  SQUARE_1M = "SQUARE_1M",
  SQUARE_10M = "SQUARE_10M",
  SQUARE_50M = "SQUARE_50M",
  /** SQUARE_REFERRAL - Used by Square accounts that sends bounty and referral payments. */
  SQUARE_REFERRAL = "SQUARE_REFERRAL",
  /**
   * GREEN_0 - Like GREEN, but every payment requires an upgrade. Risk moves customers to
   * this status level when it wants to force a customer to upgrade.
   */
  GREEN_0 = "GREEN_0",
  /**
   * PLUS_BUSINESS - Unused. Replaced with the BUSINESS rate plan.
   *
   * @deprecated
   */
  PLUS_BUSINESS = "PLUS_BUSINESS",
  /**
   * PLUS_BETA - Unused. Replaced with the BUSINESS rate plan.
   *
   * @deprecated
   */
  PLUS_BETA = "PLUS_BETA",
  /**
   * GOLD_ARIZONA - Deprecated. Use GOLD instead.
   *
   * @deprecated
   */
  GOLD_ARIZONA = "GOLD_ARIZONA",
  /**
   * PILOT - Obsolete for Beta users.
   *
   * @deprecated
   */
  PILOT = "PILOT",
  /** GIVER_150K - For accounts that give large sums of money away (usually celebrities to their fans). */
  GIVER_150K = "GIVER_150K",
  /**
   * PHONE_VERIFIED - Deprecated. Will get same benefit from new identity model.
   *
   * @deprecated
   */
  PHONE_VERIFIED = "PHONE_VERIFIED",
}
